/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getFilterSpecialty } from '../../../api/weeklyProductReportApi';
import useProductSamplingInventoryContext from '../context/useProductSamplingInventoryContext';

function Filter() {
  const { auth, setFilterForm, filterForm, searchProductList, clearProductList } = useContext(
    useProductSamplingInventoryContext,
  );

  const [specialtyOptions, setSpecialtyOptions] = useState([]);

  const loadSpecialtyOptions = async () => {
    const response = await getFilterSpecialty();
    const { code, data } = response.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.specialty,
        label: row.specialty,
      }));

      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);

      if (dropdownValue.length < 2) {
        setFilterForm({ ...filterForm, specialty: [dropdownValue[0]] });
      } else {
        setFilterForm({ ...filterForm, specialty: [{ label: 'ALL', value: null }] });
      }
    }
  };

  const handleChangeDate = (value) => {
    setFilterForm({ ...filterForm, date: moment(value).format('YYYY-MM') });
  };

  useEffect(() => {
    loadSpecialtyOptions();
  }, []);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={4}>
          <Autocomplete
            id='specialty'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={specialtyOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={Array.isArray(filterForm.specialty) ? filterForm.specialty : []}
            noOptionsText='No Specialties'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [specialtyOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [specialtyOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== specialtyOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                specialty: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Specialty' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid xs={4}>
          <DatePicker
            label='date'
            views={['month', 'year']}
            value={filterForm.date}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Date' size='small' fullWidth />}
            onChange={(value) => handleChangeDate(value)}
          />
        </Grid>
        <Grid md={4}>
          <Button variant='contained' color='success' onClick={() => searchProductList()}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={() => clearProductList()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
